import Axios from "./axios";

const resource = "promotion-shop-sliders";

export default {
  get(id) {
		return Axios.get(`${resource}?reseller_id=${id}`);
	}
}